"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var index_1 = require("../../core/utils/index");

var PriceStats_1 = require("../model/PriceStats");

var PriceStatsConverter_1 = require("./PriceStatsConverter");
/**
 * @author Jan Gregor
 */


var PriceStatsConverterImpl =
/*#__PURE__*/
function (_PriceStatsConverter_) {
  _inherits(PriceStatsConverterImpl, _PriceStatsConverter_);

  function PriceStatsConverterImpl() {
    _classCallCheck(this, PriceStatsConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(PriceStatsConverterImpl).apply(this, arguments));
  }

  _createClass(PriceStatsConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      var _this = this;

      return new PriceStats_1.PriceStats(conversions.asObjectList(source, 'currentPrices', function (doc) {
        return _this.priceToObject(doc, conversions);
      }), PriceStats_1.PriceStats.schema.lastAmount.valueOf(source.lastAmount !== null ? conversions.toBigNumber(source.lastAmount) : null), PriceStats_1.PriceStats.schema.minAmount.valueOf(source.minAmount !== null ? conversions.toBigNumber(source.minAmount) : null), PriceStats_1.PriceStats.schema.averageAmount.valueOf(source.averageAmount !== null ? conversions.toBigNumber(source.averageAmount) : null), PriceStats_1.PriceStats.schema.openingAmount.valueOf(index_1.Utils.hasValue(source.openingAmount) ? conversions.toBigNumber(source.openingAmount) : null));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "priceToObject",
    value: function priceToObject(source, conversions) {
      return new PriceStats_1.PriceStatsPrice(PriceStats_1.PriceStatsPrice.schema.id.valueOf(conversions.documentToClassId(source)), PriceStats_1.PriceStatsPrice.schema.groupOfSiteId.valueOf(conversions.toClassReferenceId(source.groupOfSiteId)), PriceStats_1.PriceStatsPrice.schema.productId.valueOf(conversions.toClassReferenceId(source.productId)), PriceStats_1.PriceStatsPrice.schema.amount.valueOf(conversions.toBigNumber(source.amount)), PriceStats_1.PriceStatsPrice.schema.dateFrom.valueOf(conversions.toDate(source.dateFrom)), PriceStats_1.PriceStatsPrice.schema.dateTo.valueOf(conversions.toDate(source.dateTo)), PriceStats_1.PriceStatsPrice.schema.promotionId.valueOf(conversions.toClassReferenceId(source.promotionId)));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this2 = this;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        currentPrices: conversions.asObjectArray(source, 'currentPrices', function (price) {
          return _this2.priceToDocument(price, conversions);
        }),
        lastAmount: source.lastAmount && conversions.fromBigNumber(source.lastAmount),
        minAmount: source.minAmount && conversions.fromBigNumber(source.minAmount),
        averageAmount: source.averageAmount && conversions.fromBigNumber(source.averageAmount),
        openingAmount: source.openingAmount && conversions.fromBigNumber(source.openingAmount)
      });
      return result;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "priceToDocument",
    value: function priceToDocument(source, conversions) {
      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        groupOfSiteId: conversions.toDocumentReferenceId(source.groupOfSiteId),
        productId: conversions.toDocumentReferenceId(source.productId),
        amount: conversions.fromBigNumber(source.amount),
        dateFrom: conversions.fromDate(source.dateFrom),
        dateTo: conversions.fromDate(source.dateTo),
        promotionId: conversions.toDocumentReferenceId(source.promotionId)
      });
      return result;
    }
  }]);

  return PriceStatsConverterImpl;
}(PriceStatsConverter_1.PriceStatsConverter);

exports.PriceStatsConverterImpl = PriceStatsConverterImpl;